import http from './http-common';

export const setAuthToken = (token: string) => {
  if (token) {
    http.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  } else {
    http.defaults.headers.common['Authorization'] = '';
  }
};

export const setSessionIdHeader = (sessionId?: string) => {
  if (sessionId) {
    http.defaults.headers.common['x-session-id'] = sessionId;
  } else {
    delete http.defaults.headers.common['x-session-id'];
  }
};
